const updates = [
    {
        title: "Machinery Of Oppression Update - 3/14/2026",
        items: [
            "Added latest warbonds - Python Commandos, Redacted Regiment, Siege Breakers",
            "Added planet modifiers(subfactions, enemy surges)",
            "Filters now support multiple fields",
            "Filters UI redesign",
            "Added Wiki links to item details pages",
            "New desktop landing page and navigation",
        ]
    },
    {
        title: "Into The Unjust Update - 10/21/2025",
        items: [
            "'Games' page renamed to 'Data'",
            "New tab 'Distributions' showing data distribution by date, planet, mission type, player level breakdowns, etc",
            "Fix a major script bug that was slowing down data collection"
        ]
    },
    {
        title: "Control Group Update - 7/28/2025",
        items: [
            "New mobile navigation",
            "Mobile friendly 'Games' page",
            "Added pickrate/rank trends to armors page",
            "Strategem details patch trends chart now shows only latest 6 patches/warbonds",
            "Fix for mobile layout issues for Strategem/Weapons details page",
            "Main charts filters state now persists between pages",
            "Fix old strategems showing as 'New' in main charts if no data collected for previous patch",
            "Fix Strategem/Weapons details hover tooltips for periods with no data",
            "Fix for some mission types not showing up",
        ]
    },
    {
        title: "Borderline Justice Update - 3/25/2025",
        items: [
            "Added Player Level",
            "Added Rank/Pickrate trends to main charts",
            "Removed trend charts",
            "Moved Games table to separate page",
            "UI and performance issues fixes",
        ]
    },
    {
        title: "Servants of Freedom Update - 2/25/2025",
        items: [
            "Added Primaries",
            "Added Portable Hellbomb",
            "Rank/pickrate display filters for strategem/weapon details page",
            "Https certificate",
            "Request performance optimizations"
        ]
    },
    {
        title: "Omens of Tyranny Update - 1/26/2025",
        items: [
            "Added The Illuminate",
            "Added Truth Enforcers and Chemical Agents warbonds strategems",
            "Strategem page redesign",
            "Trends page for previous patches",
            "Companion picks for strategems",
        ]
    }
];


export { updates }